var GetTargetReadySelectedValue = function (e) {    
    var targetReadySelectedText = $('#SelectedModelValue option:selected').text();
    $('#SelectedModelFilter').val(targetReadySelectedText);

    var targetReadySelectedVal = $('#SelectedModelValue option:selected').val();
    $('#SelectedModelFilterVal').val(targetReadySelectedVal);
    
    $('#AvailableModelRanges_Selected').empty();
   
    GetFilterValues(e, 'AvailableModelRanges_Available');
    UpdateSelectedListBoxHiddenField($('#AvailableModelRanges_Selected'), '#SerializedModelRanges', true);
};

var PopupSearch = function() {
    $('#txtSearchTargetDesc').keyup(function() {
        var textLength = $('#txtSearchTargetDesc').val().length;
        if (textLength >= 0) {
            var searchText = $('#txtSearchTargetDesc').val().toLowerCase();
            var allDivs = $('#divTargetReady');
            if (typeof searchText != 'undefined' && searchText != null && typeof allDivs != 'undefined' && allDivs !== null) {
                var children = allDivs.children();
                for (var i = 0; i < children.length; i++) {
                    var childValue = children[i].innerHTML.toLowerCase();
                    if (childValue.indexOf(searchText) > -1) {
                        $(children[i]).css("display", "block");
                    } else {
                        $(children[i]).css("display", "none");
                    }
                }
            }
        }
    });
}